import { render, staticRenderFns } from "./paiement-securise.vue?vue&type=template&id=783e90ac&scoped=true"
import script from "./paiement-securise.vue?vue&type=script&lang=js"
export * from "./paiement-securise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783e90ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/app/components/Breadcrumb.vue').default,PaymentMethodInfoItem: require('/app/components/PaymentMethodInfoItem.vue').default})
